import { PickRequestBuilder } from "ags/integration/builders/requests/pick-request-builder";
import { ForceList } from "slotworks/debug/menu/force-list";
import Contract from "slotworks/utils/contracts/contract";

class CMPickForcer implements ForceList {
    protected results = new Map<string, string>();

    public force(id: string): Contract<void> {
        PickRequestBuilder.force = this.results.has(id) ? this.results.get(id) : id;
        return Contract.empty();
    }

    public getList(): Contract<string[]> {
        return new Contract<string[]>((resolve) => {
            resolve(Array.from(this.results.keys()));
        });
    }

    public setResults(results: Map<string, string>): void {
        this.results = results;
    }
}

export default new CMPickForcer();
